import type { ReactElement, ReactNode } from 'react';
import { Tag } from 'antd';
import type { TagProps } from 'antd';

export type EntityStatusTone = 'default' | 'success' | 'warning' | 'error' | 'processing';

export function EntityStatusChip({
  children,
  tone = 'default',
  className,
  ...props
}: Omit<TagProps, 'color'> & {
  children: ReactNode;
  tone?: EntityStatusTone;
}): ReactElement {
  return (
    <Tag
      {...props}
      color={tone}
      className={['entity-status-chip', className].filter(Boolean).join(' ')}
    >
      {children}
    </Tag>
  );
}
